import { render, staticRenderFns } from "./CatalogPriceForm.vue?vue&type=template&id=f0a617c6&scoped=true"
import script from "./CatalogPriceForm.vue?vue&type=script&lang=js"
export * from "./CatalogPriceForm.vue?vue&type=script&lang=js"
import style0 from "./CatalogPriceForm.vue?vue&type=style&index=0&id=f0a617c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a617c6",
  null
  
)

export default component.exports